import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import useTheme from '@/theme/useTheme';
import { AuthMode } from './types';

interface ModeToggleButtonsProps {
  currentMode: AuthMode;
  onModeChange?: (mode: AuthMode) => void;
}

const ModeToggleButtons: React.FC<ModeToggleButtonsProps> = ({
  currentMode,
  onModeChange,
}) => {
  const { t } = useTranslation(['auth', 'common']);
  const { theme } = useTheme();
  const router = useRouter();

  const handleModeChange = (newMode: AuthMode) => {
    if (onModeChange) {
      // 内部切换模式
      onModeChange(newMode);
    } else {
      // 路由跳转模式
      router.push(`/account/${newMode}`);
    }
  };

  const buttonStyles = {
    flex: 1,
    height: { xs: '36px', sm: '40px' },
    fontSize: { xs: '0.875rem', sm: '0.9375rem' },
    fontWeight: 500,
    borderRadius: '6px',
    textTransform: 'none' as const,
    transition: 'all 0.2s ease',
    boxShadow: 'none',
  };

  const activeButtonStyles = {
    ...buttonStyles,
    backgroundColor: '#8B5CF6', // theme.palette.primary.main
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: 'none',
    },
  };

  const inactiveButtonStyles = {
    ...buttonStyles,
    backgroundColor: '#262626',
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      boxShadow: 'none',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 2.5,
      }}
    >
      <Button
        variant="contained"
        onClick={() => handleModeChange('login')}
        sx={currentMode === 'login' ? activeButtonStyles : inactiveButtonStyles}
      >
        {t('login.title')}
      </Button>
      <Button
        variant="contained"
        onClick={() => handleModeChange('register')}
        sx={
          currentMode === 'register' ? activeButtonStyles : inactiveButtonStyles
        }
      >
        {t('register.title')}
      </Button>
    </Box>
  );
};

export default ModeToggleButtons;
